import { EngineType, Interval, IntervalDays, ModeOfTransport } from "./FrontendTypes";
import EnumInput from "../components/EnumInput";
import NumberInput from "../components/NumberInput";
import { CarTrip } from "./FrontendTypes";

function createCarTrip(toCustomer: boolean): CarTrip {
    return {
        mot: ModeOfTransport.CAR,
        distance: 20,
        engineType: EngineType.PETROL,
        frequency: 1,
        interval: Interval.WEEK,
        toCustomer: toCustomer
    }
}

type Props = {
    value: CarTrip,
    setValue: React.Dispatch<React.SetStateAction<any>>
}

function CarComponent({value: car, setValue: setCar}: Props) {

    const setDistance = (newDistance: number) => {
        setCar({ ...car, distance: newDistance });
    };

    const setFrequency = (newFrequency: number) => {
        setCar({ ...car, frequency: newFrequency});
    };

    const handleEngineTypeChange = (newEngine: EngineType) => {
        setCar({ ...car, engineType: newEngine });
    };

    const handleIntervalChange = (newInterval: Interval) => {
        setCar({ ...car, interval: newInterval });
    };

    return (
        <>
            <NumberInput
                max={999}
                value={car.distance}
                setValue={setDistance}
            />
            <p>km mit</p>
            <EnumInput
                value={car.engineType}
                enumType={EngineType}
                onChange={handleEngineTypeChange}
            />
            <p>, pro</p>
            <EnumInput
                value={car.interval}
                enumType={Interval}
                onChange={handleIntervalChange}
            />
            <p>ca. </p>
            <NumberInput
                max={IntervalDays[car.interval]}
                value={car.frequency}
                setValue={setFrequency}
            />
            <p> mal</p>
        </>
    );
}

export { type CarTrip as Type, CarComponent as Component, createCarTrip as createTrip};